import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { changePasswordRequest } from '../../lib/flotiq-client/api-helpers';
import { getTestProps } from '../../lib/helpers';

import ChangePasswordRequestForm from '../../form/ChangePasswordRequestForm/ChangePasswordRequestForm';
import Authentication from '../../hoc/Authentication/Authentication';

const testId = 'change-password-request';

const ChangePasswordRequest = () => {
  const { t } = useTranslation();

  const handlePasswordChangeRequest = useCallback(
    async (email: string) => {
      return changePasswordRequest(email, t);
    },
    [t],
  );

  return (
    <>
      <title>{t('Form.FormChangePasswordRequestTitle')}</title>
      <Authentication
        headerText={t('Form.FormChangePasswordRequestHeader')}
        paragraphText={t('Form.FormChangePasswordRequestEnterEmailHowToReset')}
        {...getTestProps(testId, 'authentication', 'testId')}
      >
        <ChangePasswordRequestForm
          onSubmit={handlePasswordChangeRequest}
          {...getTestProps(testId, 'form', 'testId')}
        />
      </Authentication>
    </>
  );
};

export default ChangePasswordRequest;
